import { Location } from 'react-router-dom';
import { Step } from 'components/NewRelease/constants';
import IntlStore from 'stories/IntlStore';

export const getNewReleaseSubMenu = (location: Location) => [
  {
    id: Step.Type,
    path: {
      pathname: location.pathname,
      search: `?step=${Step.Type}`,
    },
    label: IntlStore.intl.formatMessage({
      id: "MenuItem.Releases.SubMenu.ReleaseType",
      defaultMessage: "Release type"
    })
  },
  {
    id: Step.UploadImage,
    path: {
      pathname: location.pathname,
      search: `?step=${Step.UploadImage}`,
    },
    label: IntlStore.intl.formatMessage({
      id: "MenuItem.Releases.SubMenu.CoverUpload",
      defaultMessage: "Cover upload"
    })
  },
  {
    id: Step.ReleaseInfo,
    path: {
      pathname: location.pathname,
      search: `?step=${Step.ReleaseInfo}`,
    },
    label: IntlStore.intl.formatMessage({
      id: "MenuItem.Releases.SubMenu.ReleaseInformation",
      defaultMessage: "Release information"
    }),
    subMenu: [
      {
        path: '#atrists',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.ReleaseInformation.Artists",
          defaultMessage: "Artists"
        })
      },
      {
        path: '#release-title',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.ReleaseInformation.ReleaseTitle",
          defaultMessage: "Release title"
        })
      },
      {
        path: '#release-version',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.ReleaseInformation.ReleaseVersion",
          defaultMessage: "Release version"
        })
      },
      {
        path: '#label',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.ReleaseInformation.Label",
          defaultMessage: "Label"
        })
      },
      {
        path: '#release-date',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.ReleaseInformation.ReleaseDate",
          defaultMessage: "Release date"
        })
      },
      {
        path: '#genre',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.ReleaseInformation.Genre",
          defaultMessage: "Genre"
        })
      },
      {
        path: '#ean-upc',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.ReleaseInformation.EAN",
          defaultMessage: "EAN/UPC"
        })
      },
    ]
  },
  {
    id: Step.TrackUpload,
    path: {
      pathname: location.pathname,
      search: `?step=${Step.TrackUpload}`,
    },
    label: IntlStore.intl.formatMessage({
      id: "MenuItem.Releases.SubMenu.TrackUpload",
      defaultMessage: "Track upload "
    }),
    subMenu: [
    //   {
    //     path: '#atrists',
    //     label: IntlStore.intl.formatMessage({
    //       id: "MenuItem.Releases.SubMenu.TrackUploadInformation.Artists",
    //       defaultMessage: "Artists"
    //     })
    //   },
    //   {
    //     path: '#track-title',
    //     label: IntlStore.intl.formatMessage({
    //       id: "MenuItem.Releases.SubMenu.TrackUploadInformation.TrackTitle",
    //       defaultMessage: "Track title"
    //     })
    //   },
    //   {
    //     path: '#track-language',
    //     label: IntlStore.intl.formatMessage({
    //       id: "MenuItem.Releases.SubMenu.TrackUploadInformation.TrackLanguage",
    //       defaultMessage: "Track language"
    //     })
    //   },
    //   {
    //     path: '#contributors',
    //     label: IntlStore.intl.formatMessage({
    //       id: "MenuItem.Releases.SubMenu.TrackUploadInformation.Contributors",
    //       defaultMessage: "Contributors"
    //     })
    //   },
    //   {
    //     path: '#genres',
    //     label: IntlStore.intl.formatMessage({
    //       id: "MenuItem.Releases.SubMenu.TrackUploadInformation.Genres",
    //       defaultMessage: "Genres"
    //     })
    //   },
    //   {
    //     path: '#isrc',
    //     label: IntlStore.intl.formatMessage({
    //       id: "MenuItem.Releases.SubMenu.TrackUploadInformation.ISRC",
    //       defaultMessage: "ISRC"
    //     })
    //   },
    //   {
    //     path: '#track-lyrics',
    //     label: IntlStore.intl.formatMessage({
    //       id: "MenuItem.Releases.SubMenu.TrackUploadInformation.TrackLyrics",
    //       defaultMessage: "Track lyrics"
    //     })
    //   },
    ]
  },
  {
    id: Step.TrackInfo,
    path: {
      pathname: location.pathname,
      search: `?step=${Step.TrackInfo}`,
    },
    label: IntlStore.intl.formatMessage({
      id: "MenuItem.Releases.SubMenu.TrackInformation",
      defaultMessage: "Track information"
    }),
    subMenu: [
      {
        path: '#atrists',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.TrackUploadInformation.Artists",
          defaultMessage: "Artists"
        })
      },
      {
        path: '#track-title',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.TrackUploadInformation.TrackTitle",
          defaultMessage: "Track title"
        })
      },
      {
        path: '#track-language',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.TrackUploadInformation.TrackLanguage",
          defaultMessage: "Track language"
        })
      },
      {
        path: '#contributors',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.TrackUploadInformation.Contributors",
          defaultMessage: "Contributors"
        })
      },
      {
        path: '#genres',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.TrackUploadInformation.Genres",
          defaultMessage: "Genres"
        })
      },
      {
        path: '#isrc',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.TrackUploadInformation.ISRC",
          defaultMessage: "ISRC"
        })
      },
      {
        path: '#track-lyrics',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.TrackUploadInformation.TrackLyrics",
          defaultMessage: "Track lyrics"
        })
      },
    ]
  },
  {
    id: Step.Publish,
    path: {
      pathname: location.pathname,
      search: `?step=${Step.Publish}`,
    },
    label: IntlStore.intl.formatMessage({
      id: "MenuItem.Releases.SubMenu.PlatformsCountries",
      defaultMessage: "Platforms and countries"
    }),
    subMenu: [
      {
        path: '#platforms',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.PlatformsCountries.Platforms",
          defaultMessage: "Platforms"
        })
      },
      {
        path: '#ugc-platforms',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.PlatformsCountries.UGCPlatforms",
          defaultMessage: "UGC Platforms"
        })
      },
      {
        path: '#countries',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.PlatformsCountries.Countries",
          defaultMessage: "Countries"
        })
      },
    ]
  },
  {
    id: Step.Platform,
    path: {
      pathname: location.pathname,
      search: `?step=${Step.Platform}`,
    },
    label: IntlStore.intl.formatMessage({
      id: "MenuItem.Releases.SubMenu.Review",
      defaultMessage: "Review"
    }),
    subMenu: [
      {
        path: '#release-information',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.Review.ReleaseInformation",
          defaultMessage: "Release information"
        })
      },
      {
        path: '#platform-and-countries',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.Review.PlatformCountries",
          defaultMessage: "Platform and countries"
        })
      },
      {
        path: '#final-pricing',
        label: IntlStore.intl.formatMessage({
          id: "MenuItem.Releases.SubMenu.Review.FinalPricing",
          defaultMessage: "Final pricing"
        })
      },
    ]
  },
]
